module.exports = __webpack_public_path__ + "static/media/mobile_report-ioc.e5920aae.png";